import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { Options } from 'ng5-slider';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { Socialusers } from '../_models';
import { AuthenticationService, PetsService } from '../_services';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss'],
  template: `
  <div
    class="search-results"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollDown()"
    (scrolledUp)="onScrollUp()"
  ></div>
`,
})
export class SearchPage implements OnInit {
  socialusers = new Socialusers();
  totalPetCount: any;
  totalPetCount_Lost: any;
  totalPetCount_Found: any;
  totalCount: any;
  totalDogs: any;
  totalCats: any;
  MtotalCount: any;
  MtotalDogs: any;
  MtotalCats: any;
  LostpetDetailsList: any;
  FoundpetDetailsList: any;
  LostFoundpetDetailsList: any;
  alldatalist: any;
  OperationTypeID: any = 3;
  OperationTypeHeading: string;
  petImagePath = environment.apiBaseUrl + "/Static/Images/";
  avgRegesteredPetsPerDay: number;
  public valt: number;
  public finalt: number;
  public countvalue: boolean = false;
  submitted = false;
  page = 1;
  pageSize = 12;
  zoom: any = 13;
  searchForm: FormGroup;
  lat: any;//= 59.9138688;
  lng: any;//= 7.809007;
  radiousMils: any;
  minClusterSize = 50;
  options: Options = {
    floor: 0,
    ceil: 100
  };
  currentActiveTabFilter = null;
  sum = 6;
  array = [];
  direction = "";
  throttle = 1;
  scrollDistance = 1;
  private geoCoder;
  @ViewChild('search')
  private searchElementRef: ElementRef;
  scrollUpDistance = 2;
  subscription: Subscription;
  statusText: string;
  public referPage: any = "";
  returnUrl: string;
  public checkValue = false;
  public mapCheckValue = true;
  pageType: string;
  currentUser: any;
  showpetlist: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router, private petService: PetsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private render: Renderer2) { }

  ngOnInit() {
    this.pageType = this.route.snapshot.paramMap.get("type");
    let ele = document.getElementById('navbarNav');
    this.render.removeClass(ele, "show");
    this.currentUser = this.authenticationService.currentUserValue;  
    if (this.currentUser != null && (this.currentUser.Provider.toUpperCase() == 'MINSIDE')) {
      this.showpetlist = true;
    }
  }

  public socialSignIn(socialProvider: string) {  // Just Add Google
    let socialPlatformProvider;
    if (socialProvider === 'facebook') {
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } else if (socialProvider === 'google') {
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }

    this.authService.signIn(socialPlatformProvider).then(user => {
      this.socialusers.SocialID = user.id;
      this.socialusers.FirstName = user.firstName;
      this.socialusers.LastName = user.lastName;
      this.socialusers.EmailID = user.email;
      this.socialusers.AuthToken = user.authToken;
      this.socialusers.Provider = user.provider;
      this.Savesresponse(this.socialusers);
    });
  }

  Savesresponse(socialusers: Socialusers) {
    this.authenticationService.login(socialusers).subscribe((res: any) => {
      this.socialusers = res.data;
      const today =  new Date();
      const tomorrow =  new Date(today.setDate(today.getDate() + 1));
      document.cookie = 'Authorization='+ res.JWTToken +'; expires=' + tomorrow;
      localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
      this.router.navigate([this.returnUrl]);
    })
  }

  scroll(id) {
    this.petService.changeSpecie(id);
    document.getElementById("target-el").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }

  routeToPage = () => {
    const path = this.pageType == 'lost' ? 'report-found' : 'report-lost';
    localStorage.setItem('navigatefrom', 'search');
    this.router.navigate([path]);
  }

  gotoPetList() {
    localStorage.setItem('navigatefrom', 'petlist');
    this.router.navigate(['/report-lost'], { relativeTo: this.route });
  }
}
